import * as types from '../mutation-types';
import { getOpenBidByOpenbidId } from '@/api/base';
import { Message } from 'element-gui';

const state = {
  openBidIdObj: {},
  openBidIdTwoObj: {},
  openBidIdInStages: [], // openbid集合
  openBidByIdObj: {}, // 当前openbid对象
  openBidIds: '', // openbid序列
  openBidId: '',
  openBidIdTwo: '',
  openGldCaState:1, //新增广联达E投状态
  openGetCaBackResult:1 //新增广联达E投解密成功返回状态
};

const getters = {
  getBidIdObj: (state) => state.openBidIdObj,
  getBidIdTwoObj: (state) => state.openBidIdTwoObj,
  getBidIdInStages: (state) => state.openBidIdInStages,
  getBidByIdObj: (state) => state.openBidByIdObj,
  getOpenBidIds: (state) => state.openBidIds,
  getOpenBidId: (state) => state.openBidId,
  getOpenBidIdTwo: (state) => state.openBidIdTwo,
  getOpenGldCaState: (state) => state.openGldCaState,
  getOpenGetCaBackResult: (state) => state.openGetCaBackResult
};

const actions = {
  // 根据标段id获取全局开标状态-单阶段
  async getOpenBidIdStatus({ commit }, obj) {
    await getOpenBidByOpenbidId({
      openbidId: obj.openbidId,
    }).then((res) => {
      if (res.code == 200) {
        commit(types.GET_BIDID_STATUS, res.openBid);
      } else {
        Message.error({
          message: res.data.msg,
          iconClass: 'el-icon-circle-cross1',
        });
      }
    });
  },
  // 根据标段id获取全局开标状态-多阶段
  async getOpenBidIdTwoStatus({ commit }, obj) {
    await getOpenBidByOpenbidId({
      openbidId: obj.openbidId,
    }).then((res) => {
      if (res.code == 200) {
        commit(types.GET_BIDID_TWO_STATUS, res.openBid);
      } else {
        Message.error({
          message: res.data.msg,
          iconClass: 'el-icon-circle-cross1',
        });
      }
    });
  },
  async setBidIdInStages({ commit }, obj) {
    commit(types.GET_BIDIDINSTAGES_STATUS, obj);
  },
  async setBidByIdObj({ commit }, obj) {
    commit(types.GET_BUDIDINOBJ_STATUS, obj);
  },
  async setOpenBidIds({ commit }, obj) {
    commit(types.GET_BIDIDS_STATUS, obj);
  },
  async setOpenBidId({ commit }, obj) {
    commit(types.GET_BIDIDONE_STATUS, obj);
  },
  async setOpenBidIdTwo({ commit }, obj) {
    commit(types.GET_BIDIDTWO_STATUS, obj);
  },
  async setGldetCaResult ({ commit }, obj) {
   commit(types.GET_GLDET_CA, obj);
    },
   async setGetCaBackPassResult ({ commit }, obj) {
   commit(types.GET_GLDET_BACK_RESULT_CA, obj);
    },
};

const mutations = {
  [types.GET_BIDID_STATUS](state, obj) {
    state.openBidIdObj = obj;
  },
  [types.GET_BIDID_TWO_STATUS](state, obj) {
    state.openBidIdTwoObj = obj;
  },
  [types.GET_BIDIDINSTAGES_STATUS](state, obj) {
    state.openBidIdInStages = obj;
  },
  [types.GET_BUDIDINOBJ_STATUS](state, obj) {
    state.openBidByIdObj = obj;
  },
  [types.GET_BIDIDS_STATUS](state, obj) {
    state.openBidIds = obj;
  },
  [types.GET_BIDIDONE_STATUS](state, obj) {
    state.openBidId = obj;
  },
  [types.GET_BIDIDTWO_STATUS](state, obj) {
    state.openBidIdTwo = obj;
  },
   [types.GET_GLDET_CA](state, obj) {
    state.openGldCaState = obj;
  },
    [types.GET_GLDET_BACK_RESULT_CA](state, obj) {
    state.openGetCaBackResult = obj;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
